import { baseHelper } from "lib/helpers";
import constant from "lib/constant/constant";

class ReportHelper {
  /**
   * @desc To return orders csv data
   * @param reportData array of reportData
   *
   * @return csv data
   *
   */
  reportCSVData = (
    reportData = [],
    orderSettingResponse,
    paymentSettingResponse,
    productSettingResponse,
    isCsv = false,
    isPdf = false,
    isVendor = false,
    currentUser,
    isXhawiVendor,
    isXhawi
  ) => {
    const orderSettingData = orderSettingResponse.report;
    const {
      createdAt,
      fulfillmentStatus,
      lineItemId,
      orderNumber,
      orderStatus,
      quantity,
      grossSales,
      grossProfit,
      vendorAmount,
      returns,
      shipping,
      totalSalesPrice,
      trackingNumber,
    } = orderSettingData || {};

    const {
      RETURNS,
      ORDER_NUMBER_REPORT,
      LINEITEMID,
      ORDERSTATUS,
      FULFILLMENT_STATUS,
      QUANTITYS,
      VENDOR_AMOUNT,
      CREATEDAT,
      VENDOR_ID_CUSTOM,
      SHIPPING_AMOUNT,
      VENDOR_PAID_DATE,
      VENDOR_PAYMENT_STATUS,
      TITLES,
      SKU_REPORT,
      PRODUCTTYPE,
      PRICE_REPORT,
      VENDOR_CAPITAL,
      TAX,
      DISCOUNT_REPORT,
      MARKUP_REPORT,
      PRODUCT_COST,
      CUSTOMER_PRODUCT_PRICE,
      SELLER_COMMISSION,
      TOTAL_SALES_PRICE,
      GROSS_SALES,
      GROSS_PROFIT,
      YES,
      TRACKING_NUMBER,
      VAT_ON_COMMISSION,
      VENDOR_DUE_DATE,
      COMMISSION_RATE,
      COMMISSION_TYPE,
      GATEWAY_CHARGES_TO_SELLER,
      VAT_ON_GATEWAY_CHARGES,
      GATEWAY_CHARGES_TO_OPERATOR,
      VAT_ON_OPERATOR_GATEWAY_CHARGES,
      OPERATOR_SHOPIFY_CHARGES,
      OPERATOR_COMMISSION,
      TOTAL_DISCOUNT,
      OPERATOR_VOUCHER,
      VENDOR_VOUCHER,
    } = constant;
    const paymentSettingData = paymentSettingResponse.report;
    const { vendorPaidDate, vendorPaymentStatus, sellerCommission } = paymentSettingData || {};

    const productSettingData = productSettingResponse.report;
    const { customerProductPrice, title, sku, markup, productCost, productType, price, vendor, discount, tax } =
      productSettingData || {};

    // header row

    let orderData = {
      ...(!isVendor && { id: "ID" }),
      orderNumber: (orderNumber && orderNumber.label) || ORDER_NUMBER_REPORT,
      lineItemId: (lineItemId && lineItemId.label) || LINEITEMID,
      orderStatus: (orderStatus && orderStatus.label) || ORDERSTATUS,
      fulfillmentStatus: (fulfillmentStatus && fulfillmentStatus.label) || FULFILLMENT_STATUS,
      quantity: (quantity && quantity.label) || QUANTITYS,
      createdAt: (createdAt && createdAt.label) || CREATEDAT,
      shipping: (shipping && shipping.label) || SHIPPING_AMOUNT,
      vendorPaidDate: (vendorPaidDate && vendorPaidDate.label) || VENDOR_PAID_DATE,
      vendorPaymentStatus: (vendorPaymentStatus && vendorPaymentStatus.label) || VENDOR_PAYMENT_STATUS,
      title: (title && title.label) || TITLES,
      sku: (sku && sku.label) || SKU_REPORT,
      productType: (productType && productType.label) || PRODUCTTYPE,
      price: (price && price.label) || PRICE_REPORT,
      vendorAmount: (vendorAmount && vendorAmount.label) || VENDOR_AMOUNT,
      vendor: (vendor && vendor.label) || VENDOR_CAPITAL,
      tax: (tax && tax.label) || TAX,
      trackingNumber: (trackingNumber && trackingNumber.label) || TRACKING_NUMBER,
    };
    if (isXhawi) {
      orderData = {
        id: "ID",
        orderNumber: (orderNumber && orderNumber.label) || ORDER_NUMBER_REPORT,
        lineItemId: (lineItemId && lineItemId.label) || LINEITEMID,
        orderStatus: (orderStatus && orderStatus.label) || ORDERSTATUS,
        fulfillmentStatus: (fulfillmentStatus && fulfillmentStatus.label) || FULFILLMENT_STATUS,
        quantity: (quantity && quantity.label) || QUANTITYS,
        createdAt: (createdAt && createdAt.label) || CREATEDAT,
        orderAcceptanceDate: "Order Acceptance Date",
        orderReadyToCollectDate: "Order Ready To Collect Date",
        orderPickupTime: "Order Pickup Time",
        orderDeliveryDate: "Order Delivery Date",
        vendorId: VENDOR_ID_CUSTOM,
        shipping: (shipping && shipping.label) || "Shipping Charges (Seller)",
        consignmentShipping: "Consignment Shipping",
        consignmentShippingTax: "Consignment Shipping Tax",
        vendorPaidDate: (vendorPaidDate && vendorPaidDate.label) || VENDOR_PAID_DATE,
        vendorDueDate: VENDOR_DUE_DATE,
        vendorPaymentStatus: (vendorPaymentStatus && vendorPaymentStatus.label) || VENDOR_PAYMENT_STATUS,
        title: (title && title.label) || TITLES,
        sku: (sku && sku.label) || SKU_REPORT,
        productType: (productType && productType.label) || PRODUCTTYPE,
        price: (price && price.label) || PRICE_REPORT,
        priceAfterVendorDiscount: "Price After Vendor Discount",
        vendor: (vendor && vendor.label) || VENDOR_CAPITAL,
        tax: (tax && tax.label) || TAX,
        trackingNumber: (trackingNumber && trackingNumber.label) || TRACKING_NUMBER,
      };
    } else if (isXhawiVendor) {
      orderData = {
        orderNumber: (orderNumber && orderNumber.label) || ORDER_NUMBER_REPORT,
        lineItemId: (lineItemId && lineItemId.label) || LINEITEMID,
        orderStatus: (orderStatus && orderStatus.label) || ORDERSTATUS,
        fulfillmentStatus: (fulfillmentStatus && fulfillmentStatus.label) || FULFILLMENT_STATUS,
        quantity: (quantity && quantity.label) || QUANTITYS,
        createdAt: (createdAt && createdAt.label) || CREATEDAT,
        shipping: (shipping && shipping.label) || SHIPPING_AMOUNT,
        vendorPaidDate: (vendorPaidDate && vendorPaidDate.label) || VENDOR_PAID_DATE,
        vendorDueDate: VENDOR_DUE_DATE,
        vendorPaymentStatus: (vendorPaymentStatus && vendorPaymentStatus.label) || VENDOR_PAYMENT_STATUS,
        title: (title && title.label) || TITLES,
        sku: (sku && sku.label) || SKU_REPORT,
        productType: (productType && productType.label) || PRODUCTTYPE,
        vendor: (vendor && vendor.label) || VENDOR_CAPITAL,
        trackingNumber: (trackingNumber && trackingNumber.label) || TRACKING_NUMBER,
        price: (price && price.label) || PRICE_REPORT,
        vendorAmount: (vendorAmount && vendorAmount.label) || VENDOR_AMOUNT,
        tax: (tax && tax.label) || TAX,
        discount: (discount && discount.label) || DISCOUNT_REPORT,
        markup: (markup && markup.label) || MARKUP_REPORT,
        sellerCommission: (sellerCommission && sellerCommission.label) || OPERATOR_COMMISSION,
        commissionTax: VAT_ON_COMMISSION,
        commissionRate: COMMISSION_RATE,
        commissionType: COMMISSION_TYPE,
        gatewayChargesToSeller: GATEWAY_CHARGES_TO_SELLER,
        vatOnGatewayCharges: VAT_ON_GATEWAY_CHARGES,
      };
    }

    if (isXhawi && !isVendor) {
      orderData.discount = (discount && discount.label) || DISCOUNT_REPORT;
      orderData.markup = (markup && markup.label) || MARKUP_REPORT;
      orderData.productCost = (productCost && productCost.label) || "Product Price After Commissions";
      orderData.customerProductPrice = (customerProductPrice && customerProductPrice.label) || CUSTOMER_PRODUCT_PRICE;
      orderData.sellerCommission = (sellerCommission && sellerCommission.label) || OPERATOR_COMMISSION;
      orderData.commissionTax = VAT_ON_COMMISSION;
      orderData.commissionRate = COMMISSION_RATE;
      orderData.gatewayChargesToSeller = GATEWAY_CHARGES_TO_SELLER;
      orderData.vatOnGatewayCharges = VAT_ON_GATEWAY_CHARGES;
      orderData.vendorAmount = (vendorAmount && vendorAmount.label) || VENDOR_AMOUNT;
      orderData.gatewayChargesToOperator = GATEWAY_CHARGES_TO_OPERATOR;
      orderData.vatOnOperatorGatewayCharges = VAT_ON_OPERATOR_GATEWAY_CHARGES;
      orderData.operatorShopifyCharges = OPERATOR_SHOPIFY_CHARGES;
      orderData.totalSalesPrice = (totalSalesPrice && totalSalesPrice.label) || TOTAL_SALES_PRICE;
      orderData.grossSales = (grossSales && grossSales.label) || GROSS_SALES;
      orderData.grossProfit = (grossProfit && grossProfit.label) || "Operator Gross Profit";
      orderData.paymentGateway = "Payment Gateway";
      orderData.returns = (returns && returns.label) || RETURNS;
      orderData.trackingNumber = (trackingNumber && trackingNumber.label) || TRACKING_NUMBER;
    } else if (!isVendor) {
      orderData.discount = (discount && discount.label) || DISCOUNT_REPORT;
      orderData.markup = (markup && markup.label) || MARKUP_REPORT;
      orderData.productCost = (productCost && productCost.label) || PRODUCT_COST;
      orderData.customerProductPrice = (customerProductPrice && customerProductPrice.label) || CUSTOMER_PRODUCT_PRICE;
      orderData.sellerCommission = (sellerCommission && sellerCommission.label) || SELLER_COMMISSION;
      orderData.totalSalesPrice = (totalSalesPrice && totalSalesPrice.label) || TOTAL_SALES_PRICE;
      orderData.grossSales = (grossSales && grossSales.label) || GROSS_SALES;
      orderData.grossProfit = (grossProfit && grossProfit.label) || GROSS_PROFIT;
      orderData.returns = (returns && returns.label) || RETURNS;
      orderData.trackingNumber = (trackingNumber && trackingNumber.label) || TRACKING_NUMBER;
    }

    const updatedArray = [];
    if (orderSettingData) {
      const notAllowedOrderCsvKeys = Object.keys(orderSettingData).filter((item) => {
        let hideArray;
        if (isCsv) {
          hideArray = orderSettingData[item] && orderSettingData[item].isHideCsv;
        }
        if (isPdf) {
          hideArray = orderSettingData[item] && orderSettingData[item].isHidePdf;
        }
        return hideArray;
      });

      notAllowedOrderCsvKeys.map((key) => {
        updatedArray.push(key);
        return false;
      });
    }

    if (paymentSettingData) {
      const notAllowedPaymentCsvKeys = Object.keys(paymentSettingData).filter((item) => {
        let hideArray;
        if (isCsv) {
          hideArray = paymentSettingData[item] && paymentSettingData[item].isHideCsv;
        }
        if (isPdf) {
          hideArray = paymentSettingData[item] && paymentSettingData[item].isHidePdf;
        }
        return hideArray;
      });

      notAllowedPaymentCsvKeys.map((key) => {
        updatedArray.push(key);
        return false;
      });
    }

    if (productSettingData) {
      const notAllowedProductCsvKeys = Object.keys(productSettingData).filter((item) => {
        let hideArray;
        if (isCsv) {
          hideArray = productSettingData[item] && productSettingData[item].isHideCsv;
        }
        if (isPdf) {
          hideArray = productSettingData[item] && productSettingData[item].isHidePdf;
        }
        return hideArray;
      });

      notAllowedProductCsvKeys.map((key) => {
        updatedArray.push(key);
        return false;
      });
    }

    let reportArray = [
      ...(!isVendor ? ["ID"] : []),
      (orderNumber && orderNumber.label) || ORDER_NUMBER_REPORT,
      (lineItemId && lineItemId.label) || LINEITEMID,
      (orderStatus && orderStatus.label) || ORDERSTATUS,
      (fulfillmentStatus && fulfillmentStatus.label) || FULFILLMENT_STATUS,
      (quantity && quantity.label) || QUANTITYS,
      (createdAt && createdAt.label) || CREATEDAT,
      (shipping && shipping.label) || SHIPPING_AMOUNT,
      (vendorPaidDate && vendorPaidDate.label) || VENDOR_PAID_DATE,
      (vendorPaymentStatus && vendorPaymentStatus.label) || VENDOR_PAYMENT_STATUS,
      (title && title.label) || TITLES,
      (sku && sku.label) || SKU_REPORT,
      (productType && productType.label) || PRODUCTTYPE,
      (price && price.label) || PRICE_REPORT,
      (vendorAmount && vendorAmount.label) || VENDOR_AMOUNT,
      (vendor && vendor.label) || VENDOR_CAPITAL,
      (tax && tax.label) || TAX,
      (trackingNumber && trackingNumber.label) || TRACKING_NUMBER,
    ];

    if (isXhawi) {
      reportArray = [
        "ID",
        (orderNumber && orderNumber.label) || ORDER_NUMBER_REPORT,
        (lineItemId && lineItemId.label) || LINEITEMID,
        (orderStatus && orderStatus.label) || ORDERSTATUS,
        (fulfillmentStatus && fulfillmentStatus.label) || FULFILLMENT_STATUS,
        (quantity && quantity.label) || QUANTITYS,
        (createdAt && createdAt.label) || CREATEDAT,
        "Order Acceptance Date",
        "Order Ready To Collect Date",
        "Order Pickup Time",
        "Order Delivery Date",
        VENDOR_ID_CUSTOM,
        (shipping && shipping.label) || "Shipping Charges (Seller)",
        "Consignment Shipping",
        "Consignment Shipping Tax",
        (vendorPaidDate && vendorPaidDate.label) || VENDOR_PAID_DATE,
        VENDOR_DUE_DATE,
        (vendorPaymentStatus && vendorPaymentStatus.label) || VENDOR_PAYMENT_STATUS,
        (title && title.label) || TITLES,
        (sku && sku.label) || SKU_REPORT,
        (productType && productType.label) || PRODUCTTYPE,
        (price && price.label) || PRICE_REPORT,
        "Price After Vendor Discount",
        (vendor && vendor.label) || VENDOR_CAPITAL,
        (tax && tax.label) || TAX,
        (trackingNumber && trackingNumber.label) || TRACKING_NUMBER,
      ];
    } else if (isXhawiVendor) {
      reportArray = [
        (orderNumber && orderNumber.label) || ORDER_NUMBER_REPORT,
        (lineItemId && lineItemId.label) || LINEITEMID,
        (orderStatus && orderStatus.label) || ORDERSTATUS,
        (fulfillmentStatus && fulfillmentStatus.label) || FULFILLMENT_STATUS,
        (quantity && quantity.label) || QUANTITYS,
        (createdAt && createdAt.label) || CREATEDAT,
        (shipping && shipping.label) || SHIPPING_AMOUNT,
        (vendorPaidDate && vendorPaidDate.label) || VENDOR_PAID_DATE,
        VENDOR_DUE_DATE,
        (vendorPaymentStatus && vendorPaymentStatus.label) || VENDOR_PAYMENT_STATUS,
        (title && title.label) || TITLES,
        (sku && sku.label) || SKU_REPORT,
        (productType && productType.label) || PRODUCTTYPE,
        (vendor && vendor.label) || VENDOR_CAPITAL,
        (trackingNumber && trackingNumber.label) || TRACKING_NUMBER,
        (price && price.label) || PRICE_REPORT,
        (tax && tax.label) || TAX,
        (discount && discount.label) || DISCOUNT_REPORT,
        (markup && markup.label) || MARKUP_REPORT,
        (sellerCommission && sellerCommission.label) || OPERATOR_COMMISSION,
        VAT_ON_COMMISSION,
        COMMISSION_RATE,
        COMMISSION_TYPE,
        GATEWAY_CHARGES_TO_SELLER,
        VAT_ON_GATEWAY_CHARGES,
        (vendorAmount && vendorAmount.label) || VENDOR_AMOUNT,
      ];
    }

    if (!isVendor && isXhawi) {
      reportArray.push((discount && discount.label) || DISCOUNT_REPORT);
      reportArray.push((markup && markup.label) || MARKUP_REPORT);
      reportArray.push((productCost && productCost.label) || "Product Price After Commissions");
      reportArray.push((customerProductPrice && customerProductPrice.label) || CUSTOMER_PRODUCT_PRICE);
      reportArray.push((sellerCommission && sellerCommission.label) || OPERATOR_COMMISSION);
      reportArray.push(VAT_ON_COMMISSION);
      reportArray.push(COMMISSION_RATE);
      reportArray.push(COMMISSION_TYPE);
      reportArray.push(GATEWAY_CHARGES_TO_SELLER);
      reportArray.push(VAT_ON_GATEWAY_CHARGES);
      reportArray.push((vendorAmount && vendorAmount.label) || VENDOR_AMOUNT);
      reportArray.push(GATEWAY_CHARGES_TO_OPERATOR);
      reportArray.push(VAT_ON_OPERATOR_GATEWAY_CHARGES);
      reportArray.push(OPERATOR_SHOPIFY_CHARGES);
      reportArray.push((totalSalesPrice && totalSalesPrice.label) || TOTAL_SALES_PRICE);
      reportArray.push((grossSales && grossSales.label) || GROSS_SALES);
      reportArray.push((grossProfit && grossProfit.label) || "Operator Gross Profit");
      reportArray.push("Payment Gateway");
      reportArray.push("Payment ID");
      reportArray.push(TOTAL_DISCOUNT);
      reportArray.push(OPERATOR_VOUCHER);
      reportArray.push(VENDOR_VOUCHER);
      reportArray.push((returns && returns.label) || RETURNS);
    } else if (!isVendor) {
      reportArray.push((discount && discount.label) || DISCOUNT_REPORT);
      reportArray.push((markup && markup.label) || MARKUP_REPORT);
      reportArray.push((productCost && productCost.label) || PRODUCT_COST);
      reportArray.push((customerProductPrice && customerProductPrice.label) || CUSTOMER_PRODUCT_PRICE);
      reportArray.push((sellerCommission && sellerCommission.label) || SELLER_COMMISSION);
      reportArray.push((totalSalesPrice && totalSalesPrice.label) || TOTAL_SALES_PRICE);
      reportArray.push((grossSales && grossSales.label) || GROSS_SALES);
      reportArray.push((grossProfit && grossProfit.label) || GROSS_PROFIT);
      reportArray.push((returns && returns.label) || RETURNS);
    }

    const removeIndex = [];

    updatedArray.map((updatedValue) => {
      const value = Object.keys(orderData).find((item) => item === updatedValue);
      const index = Object.keys(orderData).indexOf(value);
      removeIndex.push(index);
      return false;
    });

    const differenceArray = reportArray.filter((value, index) => !removeIndex.includes(index));

    const newReportArray = [];
    newReportArray[0] = differenceArray;

    reportData.forEach((item, idx) => {
      let customReportArray = [
        ...(!isVendor ? [`${item._id || ""}`] : []),
        `${item.orderNumber}`,
        `${item.lineItemId}`,
        `${item.orderStatus || ""}`,
        `${item.fulfillmentStatus || ""}`,
        `${item.quantity || 0}`,
        `${baseHelper.formatDate(item.createdAt)}`,
        `${item.shipping || 0}`,
        `${baseHelper.formatDate(item.vendorPaidDate)}`,
        `${item.vendorPaymentStatus || ""}`,
        `${item.title || ""}`,
        `${item.sku}`,
        `${item.productType || ""}`,
        `${item.price || 0}`,
        `${item.vendorAmount || 0 || ""}`,
        `${item.vendor || ""}`,
        `${item.tax || 0}`,
        `${item.trackingNumber || ""}`,
        (!isVendor && (item.discount || 0)) || "0",
        (!isVendor && (item.markup || 0)) || "",
        (!isVendor && (item.productCost || 0)) || "",
        (!isVendor && (item.customerProductPrice || 0)) || "",
        (!isVendor && (item.sellerCommission || 0)) || "",
        (!isVendor && (item.totalSalesPrice || 0)) || "",
        (!isVendor && (item.grossSales || 0)) || "",
        (!isVendor && (item.grossProfit || 0)) || "",
        (!isVendor && (item.returns ? YES : "")) || "",
      ];
      if (isXhawi) {
        const vatOnOperatorCommission = baseHelper.formatPrice(item.sellerCommission * 0.05 || 0);
        const gatewayChargesToSeller = ((item.paymentGateway || "") === "QPay") ? baseHelper.formatPrice((item.customerProductPrice || 0) * 0.035) : baseHelper.formatPrice((item.customerProductPrice || 0) * 0.01);
        const vatOnGatewayChargesToSeller = baseHelper.formatPrice((item.customerProductPrice || 0) * 0.01 * 0.05);
        const gatewayChargesToOperator = baseHelper.formatPrice(
          (item.customerProductPrice || 0) * 0.01 + (item.consignmentShipping || 0) * 0.01
        );
        const vatOnGatewayChargesToOperator = baseHelper.formatPrice((item.customerProductPrice || 0) * 0.01 * 0.05);
        const operatorShopifyCharges = baseHelper.formatPrice((item.customerProductPrice || 0) * 0.002);
        const vendorAmountXhawi =
          item.customerProductPrice -
          item.sellerCommission -
          vatOnOperatorCommission -
          gatewayChargesToSeller -
          vatOnGatewayChargesToSeller;
        const vendorAmountXhawiQpay = item.customerProductPrice - item.sellerCommission - vatOnOperatorCommission;
        const actualVendorAmount = ((item.paymentGateway || "") === "QPay") ? vendorAmountXhawiQpay : vendorAmountXhawi;
        customReportArray = [
          `${item._id}`,
          `${item.orderNumber}`,
          `${item.lineItemId}`,
          `${item.orderStatus || ""}`,
          `${item.fulfillmentStatus || ""}`,
          `${item.quantity || 0}`,
          `${baseHelper.formatDate(item.createdAt, true)}`,
          `${baseHelper.formatDate(item.orderAcceptanceDate, true)}`,
          `${baseHelper.formatDate(item.orderReadyToCollectDate, true,true)}`,
          `${baseHelper.formatDate(item.orderPickupTime, true,true)}`,
          `${baseHelper.formatDate(item.orderDeliveryDate, true,true)}`,
          `${item.vendorId || ""}`,
          `${item.shipping || 0}`,
          `${baseHelper.formatPrice(item.consignmentShipping || 0)}`,
          `${baseHelper.formatPrice((item.consignmentShipping || 0) - (item.consignmentShipping || 0) / 1.05)}`,
          `${baseHelper.formatDate(item.vendorPaidDate)}`,
          `${baseHelper.formatDate(item.dueDate || "", false)}`,
          `${item.vendorPaymentStatus || ""}`,
          `${item.title || ""}`,
          `${item.sku}`,
          `${item.productType || ""}`,
          `${baseHelper.formatPrice(item.price || 0)}`,
          `${baseHelper.formatPrice(item.priceAfterVendorDiscount || 0)}`,
          `${item.vendor || ""}`,
          `${baseHelper.formatPrice((item.price || 0) - (item.price || 0) / 1.05)}`, // tax calculation of 5% on the basis of product price
          `${item.trackingNumber || ""}`,
          `${baseHelper.formatPrice(item.discount || 0)}`,
          `${baseHelper.formatPrice(item.markup || 0)}`,
          `${baseHelper.formatPrice(item.productCost || 0)}`,
          `${baseHelper.formatPrice(item.customerProductPrice || 0)}`,
          `${baseHelper.formatPrice(item.sellerCommission || 0)}`,
          vatOnOperatorCommission, // vat on commission calculation of 5% on the basis of operator commission
          `${item.commissionSetting?.rate || 0}`,
          `${item.commissionSetting?.type || ""}`,
          gatewayChargesToSeller, // gateway charges to seller calculation of 1% on the basis of product price
          vatOnGatewayChargesToSeller, // VAT on Gateway charges calculation of 5% on the basis of gateway charges to seller
          ` ${baseHelper.formatPrice(actualVendorAmount || 0)}`,
          gatewayChargesToOperator, // gateway charges to operator calculation of 1% on the basis of product price adding 1% of consignement shipping
          vatOnGatewayChargesToOperator, // VAT on operator Gateway charges calculation of 5% on the basis of gateway charges to operator
          operatorShopifyCharges, // operator shopify charges calculation of 0.2% on the basis of product price
          `${baseHelper.formatPrice(item.grossSales || 0)}`,
          `${baseHelper.formatPrice(item.grossSales || 0)}`,
          `${baseHelper.formatPrice(item.grossProfit || 0)}`,
          `${item.paymentGateway}`,
          `${item.paymentId}`,
          `${item.voucherDetails?.totalDiscount || 0}`,
          `${item.voucherDetails?.operatorDiscount || 0}`,
          `${item.voucherDetails?.xhawiVendorDiscount || 0}`,
          `${item.returns ? YES : ""}`,
        ];
      }
      if (isXhawiVendor) {
        const productPrice = parseFloat(item.quantity || 0) * parseFloat(item.price || 0);
        customReportArray = [
          `${item.orderNumber}`,
          `${item.lineItemId}`,
          `${item.orderStatus || ""}`,
          `${item.fulfillmentStatus || ""}`,
          `${item.quantity || 0}`,
          `${baseHelper.formatDate(item.createdAt, false)}`,
          `${baseHelper.formatPrice(item.shipping || 0)}`,
          `${baseHelper.formatDate(item.vendorPaidDate)}`,
          `${baseHelper.formatDate(item.dueDate || "", false)}`,
          `${item.vendorPaymentStatus || ""}`,
          `${item.title || ""}`,
          `${item.sku}`,
          `${item.productType || ""}`,
          `${item.vendor || ""}`,
          `${item.trackingNumber || ""}`,
          `${baseHelper.formatPrice(item.price || 0)}`,
          `${baseHelper.formatPrice((item.price || 0) - (item.price || 0) / 1.05)}`, // tax calculation of 5% on the basis of product price
          `${baseHelper.formatPrice(item.discount || 0)}`,
          `${baseHelper.formatPrice(item.markup || 0)}`,
          `${baseHelper.formatPrice(item.sellerCommission || 0)}`,
          `${baseHelper.formatPrice(item.sellerCommission * 0.05 || 0)}`, // vat on commission calculation of 5% on the basis of operator commission
          `${item.commissionSetting?.rate || 0}`,
          `${item.commissionSetting?.type || ""}`,
          `${baseHelper.formatPrice((productPrice || 0) * 0.01)}`, // gateway charges to seller calculation of 1% on the basis of product price
          `${baseHelper.formatPrice((productPrice || 0) * 0.01 * 0.05)}`, // VAT on Gateway charges calculation of 5% on the basis of gateway charges to seller
          `${baseHelper.formatPrice(item.vendorAmount || 0)}`,
        ];
      }
      newReportArray[idx + 1] = customReportArray.filter((value, index) => {
        return removeIndex.indexOf(index) === -1;
      });
    });

    return newReportArray;
  };
}

export default new ReportHelper();
